import getAddonsCategory from 'editor/src/store/editorModules/addons/selector/getAddonsCategory';
import getRequestedVersion from 'editor/src/store/editorModules/addons/selector/getRequestedVersion';
import { increaseRequestedVersionAction, setLoadingMoreAction } from 'editor/src/store/editorModules/addons/slice';
import type { ThunkDispatch } from 'editor/src/store/hooks';
import { RootState } from 'editor/src/store/index';

import sendPostMessage from 'editor/src/util/postMessages/sendPostMessage';

const requestMoreAddonsOperation = () => (dispatch: ThunkDispatch, getState: () => RootState) => {
  dispatch(increaseRequestedVersionAction());
  dispatch(setLoadingMoreAction(true));

  const state = getState();
  const addonsCategory = getAddonsCategory(state);

  // Calculate offset based on current number of subcategories
  const currentCount = addonsCategory?.subcategories?.length || 0;

  sendPostMessage('addons.requestAddons', {
    requestVersion: getRequestedVersion(state),
    search: '',
    categoryId: undefined,
    offset: currentCount,
  });
};

export default requestMoreAddonsOperation;
